export default "__VITE_ASSET__BCvo30Vj__"